import { useMemo } from "react"
import { Block } from "@mezo-org/mezo-clay"

import { selectReferralCodes, useDappSelector } from "#/redux-state"
import { MAX_NUMBER_OF_REFERRAL_CODES } from "#/shared/constants"

import MatsInvitesCodeBox from "./MatsInvitesCodeBox"

export default function MatsInvites() {
  const referralCodes = useDappSelector(selectReferralCodes)

  const selectedReferralCodes = useMemo(
    () =>
      referralCodes ? referralCodes.slice(0, MAX_NUMBER_OF_REFERRAL_CODES) : [],
    [referralCodes],
  )

  return (
    <Block
      display="grid"
      gridTemplateColumns={["100%", "100%", "100%", "33% 33% 33%"]}
      gridTemplateRows={[
        "repeat(5, 1fr)",
        "repeat(5, 1fr)",
        "repeat(5, 1fr)",
        "1fr 1fr",
      ]}
      gridGap="scale300"
    >
      {selectedReferralCodes.map((referralCode) => (
        <MatsInvitesCodeBox
          key={`referralCode_${referralCode.code}`}
          code={referralCode.code}
          claimed={referralCode.claimed}
          claimerUsername={referralCode.claimerUsername}
        />
      ))}
    </Block>
  )
}
